export const UPDATE_NOTIFICATION_STATUS = `
mutation updateNotificationStatus(
    $input: UpdateNotificationStatusInput!
){
    updateNotificationStatus(input: $input)
    {
        ... on Notification {
            id
            name
            is_active
        }
        ... on ResultError {
            status_code
            message
        }
    }
}
`